import { SEO } from "../components/site/SEO";
import { PageHeader } from "../components/site/primitives";
import { Catalog } from "../components/site/Sections";

export default function ProductsPage() {
  return (
    <>
      <SEO
        title="Products & Trade Pricing — Build Your Selection | Emporium London"
        description="Browse Emporium London's product range and build a selection — coasters, aprons, chess sets, planters, barware, candles, gift boxes and amenities. Request tailored trade pricing and samples for your volumes."
        path="/products"
      />
      <main>
        <PageHeader
          overline="Our Products"
          title="Browse products & request trade pricing"
          intro="Add the pieces you love to your selection, choose your client type and volumes, and we'll return a tailored quote with samples and customisation options."
        />
        <Catalog />
      </main>
    </>
  );
}
